import React from "react";
import MasterLayout from "../../masterLayout/MasterLayout";
import Breadcrumb from "../../components/Breadcrumb";
import EditInsultedPageNew from "../../components/Promotion/AddPromotionPageNew";



const EditPromotionPage = () => {
  return (
    <>
      {/* MasterLayout */}
      <MasterLayout>

        {/* Breadcrumb */}
        <Breadcrumb  id="title" title2="Promotion" link2="/Promotion" title="Edit Promotion" />

        {/* AddUserLayer */}
        <EditInsultedPageNew />


      </MasterLayout>
    </>
  );
};

export default EditPromotionPage;
